import type { ActivityItem } from '../model/activity';
import type { ActivityGroup } from '../model/activity-display';
import { getDateBucketLabel } from './activity-time';

export const groupActivityByDate = (items: ActivityItem[]): ActivityGroup[] =>
  items.reduce<ActivityGroup[]>((groups, item) => {
    const label = getDateBucketLabel(item.createdAt);
    const lastGroup = groups[groups.length - 1];

    if (!lastGroup || lastGroup.label !== label) {
      return [...groups, { label, items: [item] }];
    }

    return [
      ...groups.slice(0, -1),
      {
        ...lastGroup,
        items: [...lastGroup.items, item],
      },
    ];
  }, []);
